export default "__VITE_ASSET__29782936__"